<template>
  <!-- 排行榜 -->
  <PopupDialog
    ref="PopupWindowShowRef"
    width="400px"
    :show.sync="PopupWindowShow"
    :className="'RegisterReward'"
    @close="close"
  >
    <template #center>
      <div class="modalInfo">
        <div class="modalTop">
          <img class="gou" :src="gou" alt />
          <div>{{ $t("Datalang.Login_Tip_registersuccess") }}</div>
          <div class="userSid">{{ `${$t("Datalang.home_User_ID1")}: ${userInfo.sid || ""}` }}</div>
          <div class="amount" v-if="isAmount">
            {{ $t("Datalang.wallet_Get") }}&nbsp;{{ coinObj[rewardObj.coinCode]?.symbol }}&nbsp;{{
              divideAccuracy(rewardObj.amount, coinObj[rewardObj.coinCode]?.accuracy, true)
            }}
          </div>
          <div class="amount" v-if="isBet">
            {{ $t("Datalang.wallet_Get") }}&nbsp;{{ rewardObj.rewardInfo?.total_times }}&nbsp;{{
              $t("Datalang.app_free_BET")
            }}
          </div>
        </div>
        <div class="modalMain">
          <div class="promoImageDiv">
            <img class="promoImage" :src="$utils.returnImgUrl(rewardObj.rewardInfo.language?.promoImage)" alt />
          </div>
          <div class="moadlTxt">
            <div v-html="rewardObj.rewardInfo.language?.tipTxt"></div>
            <el-button class="btnStr" type="primary" size="medium" @click="handleClick">
              {{ rewardObj.rewardInfo.language?.buttonText }}
            </el-button>
          </div>
        </div>
      </div>
    </template>
  </PopupDialog>
</template>

<script>
import RegisterReward from "@/lobby_common/mixins_components/RegisterReward/index.js";
import PopupDialog from "@/components/PopupDialog";
export default {
  components: {
    PopupDialog,
  },
  props: [],
  mixins: [RegisterReward],
  data() {
    return {};
  },
  filters: {},
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.RegisterReward {
  ::v-deep .el-dialog__header {
    height: 0px;
    .title-box {
      border-bottom: none;
    }
  }
  ::v-deep .el-dialog__body {
    padding: 0 12.5px 15px;
  }
}

.modalTop {
  text-align: center;
  .gou {
    width: 70px;
    margin: 18px auto 3px;
  }
  .userSid {
    font-size: 12px;
    color: var(--font-color-900);
    border: 1px solid var(--border-color-400);
    padding: 5px 15px;
    border-radius: var(--radius-100);
    display: inline-block;
    margin: 8px auto 10px;
  }
  .amount {
    font-size: 24px;
    color: var(--font-color-1600);
  }
}
.modalMain {
  padding: 12px;
  margin-top: 10px;
  border-radius: var(--radius-300);
  background: var(--background-801);
  display: flex;
  .promoImageDiv {
    flex-shrink: 0;
  }
  .promoImage {
    max-width: 90px;
    margin-right: 10px;
    border-radius: var(--radius-300);
  }
  .moadlTxt {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow-wrap: break-word;
    .btnStr {
      @include buttonPrimary;
      animation: scalePulse 0.5s infinite ease-in-out;
    }
  }
  @keyframes scalePulse {
    0%,
    100% {
      transform: scale(1);
    }
    50% {
      transform: scale(0.95);
    }
  }
}
</style>
